import { Component, inject, OnInit } from '@angular/core';
import { LoggerService, PackageVersionsLoggerService } from '@aruba/common-lib';
import { TranslocoLangDetectorService } from '@shared/transloco/transloco-lang-detector.service';
import packageJson from '../../package.json';
import { environment } from '../environments/environment';
import { AuthService, DelegationPecMailService } from './core/services';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  private readonly authService = inject(AuthService);
  private readonly loggerService = inject(LoggerService);
  private readonly delegationPecMailService = inject(DelegationPecMailService);
  private readonly packageVersionsLogger = inject(PackageVersionsLoggerService);
  private readonly translocoLangDetectorService = inject(TranslocoLangDetectorService);

  title = 'supervisore360';

  constructor() {
    this.configureOauth2();
    this.translocoLangDetectorService.setBrowserLangIfNotSelected();
    this.delegationPecMailService.init();
  }

  ngOnInit(): void {
    this.packageVersionsLogger.logPackageVersions(packageJson);
    this.loggerService.logCircle(`L.c.h: ${environment.lastCommitHash}`, 'white', 'orange');
  }

  private configureOauth2() {
    this.authService.runInitialLoginSequence();
  }
}
